const TRANSLATIONS_EN = {
    connectionError: 'Connection error. Click to retry.'
};

export default TRANSLATIONS_EN;
